import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { loaderIndicator } from '@animations/loader';
import { slideDown } from '@animations/slide';
import { EventTrackerService } from '@commons/tracker/event-tracker/event-tracker.service';
import { FileService } from '@core/services/file.service';
import { RouterState } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay, take } from 'rxjs/operators';

@Component({
  selector: 'form-application',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideDown(), loaderIndicator()],
})
export class FormComponent {
  @Input() loading: boolean;
  @Input() error: any;
  @Input() jobId: string;
  @Output() submitSend = new EventEmitter<{ form: FormGroup; jobId: string }>();

  applicationForm: FormGroup;
  uploadPercent$: Observable<number>;
  utms$: Observable<{ key: string; value: string }[]>;

  constructor(
    readonly store: Store,
    private readonly formBuilder: FormBuilder,
    private readonly fileService: FileService,
    private readonly eventTrackerService: EventTrackerService
  ) {
    this.uploadPercent$ = this.fileService.uploadPercent$;

    this.applicationForm = this.formBuilder.group({
      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
      presentation: [''],
      cv: ['', Validators.required],
    });

    this.utms$ = combineLatest([
      store.select(RouterState.state).pipe(
        map((state: any) => Object.keys(state.queryParams).filter(key => key.startsWith('utm_'))),
        distinctUntilChanged()
      ),
      store.select(RouterState.state).pipe(
        map((state: any) => state.queryParams),
        distinctUntilChanged()
      ),
    ]).pipe(
      map(([keys, queryParams]) => keys.map(key => ({ key, value: queryParams[key] }))),
      shareReplay()
    );
  }

  get form() {
    return this.applicationForm.controls;
  }

  addFile() {
    const cvForm: AbstractControl = this.applicationForm.get('cv');

    this.fileService
      .create(cvForm.value)
      .pipe(take(1))
      .subscribe(fileCreated => {
        cvForm.patchValue(fileCreated);
        this.eventTrackerService.send({
          eventAction: 'Click Add Cv',
          eventCategory: 'Application',
        });
      });
  }
}
